import styles from "./EmptyState.module.scss";

const EmptyState = ({
  hasWriteAccess,
  onAddFirst,
  hasFilters
}) => {
  const getMessage = () => {
    if (hasFilters) {
      return {
        title: "No matching entries found",
        subtitle: "Try adjusting your search criteria or filters to find what you're looking for.",
        icon: "🔍"
      };
    }
    
    return {
      title: "No blacklist entries yet",
      subtitle: "You haven't blacklisted any contacts or domains from receiving RFQ notifications.",
      icon: "📭"
    };
  };

  const { title, subtitle, icon } = getMessage();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.icon}>
          {icon}
        </div>
        
        <h3 className={styles.title}>
          {title}
        </h3>
        
        <p className={styles.subtitle}>
          {subtitle}
        </p>

        {!hasFilters && hasWriteAccess && (
          <div className={styles.actions}>
            <button 
              className={styles.addButton}
              onClick={onAddFirst}
            >
              Add to Blacklist
            </button>
          </div>
        )}

        {!hasFilters && (
          <div className={styles.info}>
            <div className={styles.infoSection}>
              <h4 className={styles.infoTitle}>What is Contact Blacklist?</h4>
              <p className={styles.infoText}>
                The blacklist helps you manage which contacts and domains should not receive RFQ notifications. 
                You can blacklist specific customer contacts or entire email domains.
              </p>
            </div>

            <div className={styles.features}>
              <div className={styles.feature}>
                <span className={styles.featureIcon}>👤</span>
                <div className={styles.featureContent}>
                  <h5 className={styles.featureTitle}>Contact Blacklist</h5>
                  <p className={styles.featureText}>
                    Block specific customer contacts from receiving RFQ notifications
                  </p>
                </div>
              </div>

              <div className={styles.feature}>
                <span className={styles.featureIcon}>🌐</span>
                <div className={styles.featureContent}>
                  <h5 className={styles.featureTitle}>Domain Blacklist</h5>
                  <p className={styles.featureText}>
                    Block all email addresses from specific domains (e.g., competitors, invalid domains)
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;